<template>
    <a
        :href="url"
        target="_blank"
        rel="noopener noreferrer"
        :class="[
            isLarge
                ? 'p-component p-button p-button-secondary p-button-outlined p-button-icon p-button-icon-only'
                : 'text-white transition-colors desktop:hover:text-[#4064AC]',
            isShareButton ? 'p-button-share' : '',
        ]"
    >
        <svg
            v-if="isShareButton"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="20"
            viewBox="0 0 12 20"
            fill="none"
        >
            <path
                d="M1.27131 10.652H3.46363V19.6774C3.46363 19.8556 3.60802 20 3.78621 20H7.50338C7.68157 20 7.82596 19.8556 7.82596 19.6774V10.6945H10.3462C10.5101 10.6945 10.648 10.5715 10.6667 10.4088L11.0494 7.08606C11.06 6.99465 11.031 6.9031 10.9698 6.83452C10.9086 6.76587 10.821 6.72658 10.7291 6.72658H7.82609V4.64374C7.82609 4.01587 8.16415 3.69748 8.83099 3.69748C8.92602 3.69748 10.7291 3.69748 10.7291 3.69748C10.9072 3.69748 11.0516 3.55303 11.0516 3.3749V0.324968C11.0516 0.146774 10.9072 0.0023871 10.7291 0.0023871H8.11325C8.0948 0.00148387 8.05383 0 7.99344 0C7.53957 0 5.96196 0.0890967 4.71576 1.23555C3.33499 2.506 3.52692 4.02716 3.57279 4.2909V6.72652H1.27131C1.09312 6.72652 0.94873 6.8709 0.94873 7.0491V10.3294C0.94873 10.5075 1.09312 10.652 1.27131 10.652Z"
                fill="fill-current"
            />
        </svg>

        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M4.21705 8.5216H5.97091V15.7419C5.97091 15.8845 6.08642 16 6.22897 16H9.2027C9.34526 16 9.46077 15.8845 9.46077 15.7419V8.55561H11.477C11.6081 8.55561 11.7184 8.45724 11.7333 8.32702L12.0396 5.66885C12.048 5.59572 12.0248 5.52248 11.9759 5.46761C11.9269 5.4127 11.8568 5.38126 11.7832 5.38126H9.46087V3.71499C9.46087 3.2127 9.73132 2.95799 10.2648 2.95799C10.3408 2.95799 11.7832 2.95799 11.7832 2.95799C11.9258 2.95799 12.0413 2.84243 12.0413 2.69992V0.259974C12.0413 0.117419 11.9258 0.00190968 11.7832 0.00190968H9.6906C9.67584 0.0011871 9.64306 0 9.59475 0C9.23166 0 7.96956 0.0712774 6.97261 0.988439C5.86799 2.0048 6.02154 3.22173 6.05824 3.43272V5.38121H4.21705C4.07449 5.38121 3.95898 5.49672 3.95898 5.63928V8.26348C3.95898 8.40604 4.07449 8.5216 4.21705 8.5216Z"
                class="fill-current"
            />
        </svg>
    </a>
</template>

<script>
export default {
    name: 'Linkedin',
    props: {
        url: {
            type: String,
            required: true,
        },
        isLarge: {
            type: Boolean,
            required: false,
            default: false,
        },
        isShareButton: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped></style>
